import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callOpenWorkOrderForSale } from '../../../utilities/openWorkOrder';
import Config from '../../../Config';
import { setRules } from './rules';
import ProviderManager from '../../../provider/providerManager';
import { getRecaptchaToken } from '../../../utilities/recaptcha/recaptcha';
import { setFormDetails } from '../SaleBlock/OTPVerifyPhone/OTPVerifyPhoneSlice';
import { eSimSaleType, ButtonMode, CellularModeEnum } from './Esim/esimEnums';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';

export const getSaleCatalogAsync = createAsyncThunk('saleBlock/getSaleCatalogAsync', async (data, thunkAPI) => {
  try {
    const state = thunkAPI.getState().saleBlock;

    const blockId = state.epiServer.blockId;
    const offerId = 'BUNTRP1'; //state.epiServer.offerId;
    const infraType = 'FB';

    const result = await ProviderManager.getProviderData('getSaleCatalog', [blockId, offerId, infraType]);
    return result?.Body;
  } catch (error) { }
});

export const checkUserAsync = createAsyncThunk('saleJetBlock/checkUserAsync', async (data, thunkAPI) => {
  try {
    //thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().saleBlock;
    const authentication = thunkAPI.getState().authentication;

    const params = {
      isCustomerExists: authentication.loginData.isFullAuthenticated,
      id: state.personalInfo.id,
      subscriberNo: state.otpPhone,
      firstName: state.personalInfo.firstName,
      lastName: state.personalInfo.lastName,
      saleType: state.saleType,
      isReplaceMode: false,
    };

    const result = await ProviderManager.getProviderData('checkUser', params);

    return result?.Body;
  } catch (error) {
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {
  epiServer: {
    blockId: 0,
    saleBlock: {},
    configuration: {},
    service: {},
    creditIndicatorLink: '',
    creditIndicatorTitle: '',
  },
  cellularOrderdetails: {
    buttonsMode: ButtonMode.INITSTATE,
    buttonsModeType: CellularModeEnum.SIM,
    isEsimNiudExistOnOrder: false,
  },
  esim: {
    isRegularSimClicked: false,
    isEsimClicked: false,
    products: {
      index: 0,
    },
    eSimPrice: 0,
    simPrice: 0,
    saleType: eSimSaleType.simOnly,
    esimUrl: '',
    allowEsimProcess: false,
    mobilizationActivationUrl: null,
    InstructionEsim: [],
    InstructionEsimNiud: [],
  },
  isFamilyPackage: false,
  isInitSaleComplete: false,
  saleType: '', //tv|app|cellular|internet
  loginTemplate: '',
  page: '',
  percent: '0',
  progressBarPoints: [],
  flowType: 'newCustomer', //existsCustomer|newCustomer
  saleDetails: {},
  checkUser :{},
  chooseNumber: {},
  productsInfo: { products: [], selectedPhoneIndex: 0 },
  premiumPackages: [],
  selectedAddress: {},
  isUserAddressLoaded: false,
  isOtherAddress: false,
  isSkipToNewCustomer: false,
  isCustomerExposureSuccess: false,
  userAddresses: {},
  personalInfo: {},
  accountInfo: {},
  otpPhone: '',
  otpCode: '',
  otpTicketId: '',
  otpIdentity: '',
  wrongOtpMessage: '',
  numOfAttempts: 0,
  payment: {},
  phoneForDelivery: '',
  technicianArrivalTime: {},
  technicianArrivalTimeIbc: {},
  setupDeliveries: {},
  isCustomerConnectedToIbc: false,
  nvIipSeq: '',
  isMeshUpgrade: false,
  supplyType: '', //technician | delivery
  packageType: 'none', //none | open | closed
  totalPrice: 0,
  totalPriceOneTime: 0,
  deliveryCost: 0,
  isProductUpgraded: false,
  ban: '',
  isSubmit: false,
  isValid: false,
  error: { isDisplay: false, id: 0 },
  togglePopover: false,
  PrettyNumChosenCount: 0,
  RegularNumChosenCount: 0,
};
const saleBlockSlice = createSlice({
  name: 'saleBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initSale: {
      reducer: (state, action) => {
        state.saleType = getSaleTypeName(action.payload.epiSaleType);
        state.loginTemplate = getLoginTemplate(state.saleType);
        state.premiumPackages = action.payload.premiumPackages;
        state.progressBarPoints = getProgressBarPoints(state.saleType, state.flowType);
        state.productsInfo = action.payload.productsInfo;
        state.flowType = action.payload.flowType;
        state.page = action.payload.page;
        state.packageType = action.payload.packageType;
        state.totalPrice = action.payload.totalPrice;
        state.selectedAddress = action.payload.selectedAddress;
        state.technicianArrivalTime = action.payload.technicianArrivalTime;
        state.personalInfo = action.payload.personalInfo;
        state.otpPhone = action.payload.otpPhone;
        state.otpIdentity = action.payload.otpIdentity;

        //epiServer
        state.epiServer.blockId = action.payload.blockId;
        state.epiServer.saleBlock = action.payload.saleBlockData;
        state.epiServer.configuration = action.payload.configuration;
        state.epiServer.service = action.payload.service;
        state.epiServer.products = state.productsInfo.products;
        state.epiServer.offerInfo = action.payload.offerInfo;
        state.epiServer.creditIndicatorLink = action.payload.creditIndicatorLink;
        state.epiServer.creditIndicatorTitle = action.payload.creditIndicatorTitle;
        state.isInitSaleComplete = true;
        //esim
        if (action.payload?.esim) {
          state.esim = action.payload.esim;
        }
        state.isFamilyPackage = action.payload.isFamilyPackage;
      },
      prepare: (action) => {
        let payload = {};
        const saleBlock = action.saleBlock;
        const epiSaleType = saleBlock.saleCatalog.expandedValue[0].listOffers.expandedValue[0].listServices.expandedValue[0].type.value;
        const epiConfiguration = saleBlock.saleCatalog.expandedValue[0].configuration.expandedValue[0];
        const epiService = saleBlock.saleCatalog.expandedValue[0].listOffers.expandedValue[0].listServices.expandedValue[0];
        const epiOffers = saleBlock.saleCatalog.expandedValue[0].listOffers.expandedValue;
        const blockId = saleBlock.contentLink.id;
        const creditIndicatorLink = saleBlock.creditIndicatorLink.value;
        const creditIndicatorTitle = saleBlock.creditIndicatorTitle.value;
        let offerInfo = { title: '', basePrice: 0 };
        let totalPrice = 0;
        const saleBlockData = {
          urlLead: saleBlock.urlLead?.value,
          urlGoogle: saleBlock.urlGoogle?.value,
          urlApple: saleBlock.urlApple?.value,
          instructionLink: saleBlock.instructionLink?.value,
          orderSuccessTitle: saleBlock.orderSuccessTitle?.value,
          orderSuccessDescriptionDelivery: saleBlock.orderSuccessDescriptionDelivery?.value,
          orderSuccessDescriptionTechnician: saleBlock.orderSuccessDescriptionTechnician?.value,
          epiOffers: epiOffers,
          supportedTVText: saleBlock.supportedTVText?.value,
          urlToChangePackage: saleBlock.urlToChangePackage?.value,
          generalTermsAgreementLink: buildUrl(saleBlock.generalTermsAgreementLink?.value),
          advertisingInfoLink: buildUrl(saleBlock.advertisingInfoLink?.value),
        };
        const configuration = {
          isAllowTechnitian: !!epiConfiguration.isAllowTechnitian.value,
          isAllowDelivery: !!epiConfiguration.isAllowDelivery.value,
          isDisplaySuperWifi: !!epiConfiguration.isDisplaySuperWifi.value,
          deliveryCost: epiConfiguration.deliveryCost.value,
          deliveryCostForToday: epiConfiguration.deliveryCostForToday.value,
          isShowSuggestionAtEnd: !!epiConfiguration.isShowSuggestionAtEnd.value,
          suggestionButtonText: epiConfiguration.suggestionButtonText.value,
          welcomeText: epiConfiguration.welcomeText.value,
          shortDesc: epiConfiguration.shortDesc.value,
          suggestionCallBackCode: epiConfiguration.suggestionCallBackCode.value,
          suggestionTitle: epiConfiguration.suggestionTitle.value,
          SuggestionSuccessText: epiConfiguration.suggestionSuccessText.value,
          isShowAppDownloadLinks: !!epiConfiguration.isShowAppDownloadLinks.value,
        };
        payload.epiSaleType = epiSaleType;
        payload.saleBlockData = saleBlockData;
        //payload.epiConfiguration = epiConfiguration;
        //payload.epiService = epiService;
        //payload.epiOffers = epiOffers;
        payload.blockId = blockId;
        payload.configuration = configuration;
        let productsRoles = [];
        epiService.listRules?.expandedValue?.map((data, index) => {
          if (data.isEnabled.value) {
            let rule = {
              index: index,
              key: data.key.value,
              title: data.title.value,
              value: data.value.value,
              isEnabled: !!data.isEnabled?.value,
            };
            productsRoles.push(rule);
          }
        });
        const service = {
          rules: productsRoles,
          type: epiService.type.value,
          bpKey: epiService.bpKey.value,
          package: epiService.package.value,
          combSeq: epiService.combSeq.value,
          zterm: epiService.zterm.value,
          additionalPrice: epiService.additionalPrice.value,
          minimumProducts: epiService.minimumProducts.value,
          maximumProducts: epiService.maximumProducts.value,
        };
        payload.service = service;
        if (epiOffers && epiOffers.length > 0) {
          let products = [];
          let productsForUpgrade = [];
          let bezeqFiberProducts = [];
          const offerId = epiOffers[0].contentLink.id;
          const epiTitle = epiOffers[0].title.value;
          const epiBasePrice = epiOffers[0].basePrice.value;
          offerInfo.offerId = offerId;
          offerInfo.title = epiTitle;
          offerInfo.basePrice = epiBasePrice;
          totalPrice = epiBasePrice;
          epiOffers.map((offer, i) => {
            const offerId = offer.contentLink.id;
            //products
            const listProducts = offer.listServices.expandedValue[0].listProducts.expandedValue;
            products.push.apply(products, getProducts(listProducts, offerId));
            //productsForUpgrade
            const listProductsForUpgrade = offer.listServices.expandedValue[0].listProductsForUpgrade.expandedValue;
            productsForUpgrade.push.apply(productsForUpgrade, getProducts(listProductsForUpgrade, offerId));
            //bezeqFiberProducts
            const listBezeqFiberProducts = offer.listServices.expandedValue[0].listBezeqFiberProducts.expandedValue;
            bezeqFiberProducts.push.apply(bezeqFiberProducts, getProducts(listBezeqFiberProducts, offerId));
          });
          products = distinct(products);
          productsForUpgrade = distinct(productsForUpgrade);
          bezeqFiberProducts = distinct(bezeqFiberProducts);
          let baseProduct = products.find((item) => {
            return item.minimumQuantity == 1;
          });
          baseProduct = baseProduct ? baseProduct : products[0];
          const baseProductWithRule = setRules(productsRoles, baseProduct, 0);
          baseProductWithRule.isSelected = true;
          var costumerProduct = {
            count: 1,
            products: [baseProductWithRule],
          };
          let productsInfo = {
            baseProduct: baseProduct,
            products: [costumerProduct],
            productsForUpgrade: productsForUpgrade,
            bezeqFiberProducts: bezeqFiberProducts,
            allProducts: products,
            selectedProducts: [],
            selectedPhoneIndex: 0,
          };
          let saleType = getSaleTypeName(epiSaleType);
          let page = 'welcomePage';
          let packageType = '';
          let selectedAddress = {};
          let technicianArrivalTime = {};

          let personalInfo = {};
          let otpPhone = '';
          let otpIdentity = '';
          let flowType = 'newCustomer';

          if (saleType == 'app') {
            productsInfo.selectedProducts = [baseProductWithRule];
          }
          if (saleType == 'internet') {
            page = 'addressFormPage';
            if (epiOffers.length == 1) {
              const isInternetOpenPackage =
                epiOffers[0].listServices.expandedValue[0].listProducts.expandedValue[0].isInternetOpenPackage.value;
              packageType = isInternetOpenPackage ? 'open' : 'closed';
              productsInfo.selectedProducts.push(baseProduct);
              totalPrice = parseFloat((totalPrice + baseProduct.additionalPrice).toFixed(2));
            } else {
              packageType = 'none';
              offerInfo = { title: '', basePrice: 0 };
              totalPrice = 0;
            }
            //--------- checkForAddressInStorage ---------
            var storage = window.localStorage || window.sessionStorage;
            let fiberData;
            try {
              fiberData = JSON.parse(storage.getItem('fiberData'));
            } catch (e) { }
            if (fiberData) {
              selectedAddress = {
                city: fiberData.form.city,
                cityName: fiberData.form.cityName,
                street: fiberData.form.street,
                streetName: fiberData.form.streetName,
                home: fiberData.form.home,
                apartment: '',
                enter: '',
                zipCode: fiberData.form.zipCode,
                infrastructure: fiberData.infrastructure,
              };
              technicianArrivalTime = fiberData.technicianArrivalTime;
              page = 'loginPage';
              storage.removeItem('fiberData');
            }
            //--------- checkForAddressInStorage ---------
          }
          if (saleType == 'cellular') {
            const isFamilyPackage = !!saleBlock?.isFamilyPackage?.value;
            payload.isFamilyPackage = isFamilyPackage;
            let esim = {};
            if (saleBlock?.esimData.expandedValue) {
              esim = {
                esimUrl: saleBlock?.esimData?.expandedValue[0]?.esimInstallationUrl?.value,
                allowEsimProcess: saleBlock?.esimData?.expandedValue[0]?.allowEsimProcess?.value ? true : false,
                mobilizationActivationUrl: saleBlock?.esimData?.expandedValue[0]?.mobilizationActivationUrl?.value,
                InstructionEsim: saleBlock?.esimData?.expandedValue[0]?.instructionEsim,
                InstructionEsimNiud: saleBlock?.esimData?.expandedValue[0]?.instructionEsimNiud,
                cellularOrderdetails: {
                  buttonsMode: ButtonMode.INITSTATE,
                  buttonsModeType: CellularModeEnum.SIM,
                  cellularOrderdetails: false,
                },
                esimData: saleBlock?.esimData?.expandedValue[0],
              };
            }
            payload.esim = esim;
            const store = EpiContext.getStore();
            const state = store.getState();
            if (isFamilyPackage) {
              const id = state.authentication?.loginData?.userDetails?.IDNumber;
              const firstName = state.authentication?.loginData?.userDetails?.firstName;
              const lastName = state.authentication?.loginData?.userDetails?.lastName;
              const contactNumber = state.authentication?.loginData?.userDetails?.contactNumber;

              personalInfo.id = id;
              personalInfo.firstName = firstName;
              personalInfo.lastName = lastName;
              otpPhone = contactNumber;
              otpIdentity = id;
              flowType = 'existsCustomer';
              if (state.authentication.loginData.isFullAuthenticated) {
                page = 'chooseNumberPage';
              } else {
                page = 'loginPage';
              }
            } else {
              page = 'welcomePage';
            }
          }

          if (window.location.href.indexOf('#newcustomer') != -1) {
            page = '';
          }
          let premiumPackages = getPremiumPackages(epiOffers[0].listPremiumPackages.expandedValue);
          payload.productsInfo = productsInfo;
          payload.offerInfo = offerInfo;
          payload.premiumPackages = premiumPackages;
          payload.totalPrice = totalPrice;
          payload.saleType = saleType;
          payload.flowType = flowType;
          payload.page = page;
          payload.packageType = packageType;
          payload.selectedAddress = selectedAddress;
          payload.technicianArrivalTime = technicianArrivalTime;
          payload.creditIndicatorLink = creditIndicatorLink;
          payload.creditIndicatorTitle = creditIndicatorTitle;
          payload.personalInfo = personalInfo;
          payload.otpPhone = otpPhone;
          payload.otpIdentity = otpIdentity;
        }
        return { payload: payload };
      },
    },
    redirectToLogin: {
      reducer: (state, action) => { },
      prepare: (action) => {
        return { payload: action };
      },
    },
    goToPage: (state, action) => {
      state.page = action.payload.page;
      state.percent = action.payload.percent;
    },
    navigateTo: (state, action) => {
      // action for invoke saveHistory function
    },
    setFlowType: (state, action) => {
      state.flowType = action.payload.flowType;
      state.progressBarPoints = getProgressBarPoints(state.saleType, state.flowType);
    },
    setSaleDetails: (state, action) => {
      state.saleDetails = action.payload;
    },
    addSelectedPhone: (state, action) => {
      state.chooseNumber.isExistPhone = action.payload.isExistPhone;
      state.chooseNumber.existPhone = action.payload.existPhone;
      state.chooseNumber.newPhone = action.payload.newPhone;
      //let baseProduct = state.productsInfo.baseProduct;
      let baseProduct = setRules(state.epiServer.service.rules, state.productsInfo.baseProduct, state.productsInfo.selectedProducts.length);
      baseProduct.isExistPhone = action.payload.isExistPhone;
      baseProduct.existPhone = action.payload.existPhone;
      baseProduct.newPhone = action.payload.newPhone;
      baseProduct.isPrettyNum = action.payload.prettyPhoneData.isPrettyPhone;

      if (state.productsInfo.selectedPhoneIndex == state.productsInfo.selectedProducts.length) {
        state.totalPrice = parseFloat((state.totalPrice + baseProduct.additionalPrice).toFixed(2));
        state.totalPriceOneTime = parseFloat((state.totalPriceOneTime + baseProduct.oneTimeFee).toFixed(2));
      }

      state.productsInfo.selectedProducts[state.productsInfo.selectedPhoneIndex] = baseProduct;

      //reset esim cellular state
      state.esim.isEsimClicked = false;
      state.esim.isRegularSimClicked = false;
    },
    removeSelectedPhone: (state, action) => {
      const index = action.payload?.index >= 0 ? action.payload.index : null;
      const selectedProduct = index != null ? state.productsInfo.selectedProducts[index] : state.productsInfo.selectedProducts.pop();
      if (index != null) {
        state.productsInfo.selectedProducts.splice(index, 1);
      }
      if (state.productsInfo.selectedProducts.length > 0) {
        var isChooseNumberFound = state.productsInfo.selectedProducts.find((x) => x.newPhone == state.chooseNumber.newPhone);
        if (!isChooseNumberFound) {
          var lastProductIndex = state.productsInfo.selectedProducts.length - 1;
          state.chooseNumber.isExistPhone = state.productsInfo.selectedProducts[lastProductIndex].isExistPhone;
          state.chooseNumber.existPhone = state.productsInfo.selectedProducts[lastProductIndex].existPhone;
          state.chooseNumber.newPhone = state.productsInfo.selectedProducts[lastProductIndex].newPhone;
        }
      } else {
        state.chooseNumber = {};
      }
      state.totalPrice = parseFloat((state.totalPrice - selectedProduct.additionalPrice).toFixed(2));
      state.totalPriceOneTime = parseFloat((state.totalPriceOneTime - selectedProduct.oneTimeFee).toFixed(2));
      if (selectedProduct.selectedVasList?.length > 0) {
        selectedProduct.selectedVasList.forEach((vas) => {
          state.totalPrice = parseFloat((state.totalPrice - vas.price).toFixed(2));
        });
      }
    },
    setCellularServices: (state, action) => {
      //state.cellularServices = action.payload;
      const selectedProduct = state.productsInfo.selectedProducts.pop();
      selectedProduct.cellularServices = action.payload;
      state.productsInfo.selectedProducts.push(selectedProduct);
    },
    setProductsInfo: (state, action) => {
      state.productsInfo = action.payload.productsInfo;
    },
    addProduct: (state, action) => {
      state.productsInfo.products.push(action.payload.product);
      state.totalPrice = state.totalPrice + action.payload.product.products.find((x) => x.isSelected).additionalPrice;
    },
    setSelectedProducts: (state, action) => {
      state.productsInfo.selectedProducts = getSelectedProducts(state.productsInfo.products);
    },
    removeProduct: (state, action) => {
      state.productsInfo.products.splice(action.payload.index, 1);
      state.productsInfo.products = setCustomerProducts(
        state.productsInfo.allProducts,
        state.productsInfo.products,
        state.epiServer.service.rules
      );
      state.totalPrice = action.payload.basePrice + getTotalProductsPrice(state.productsInfo.products);
    },
    updateSimPrices: (state, action) => {
      state.esim.eSimPrice = action.payload.esimPrice;
      state.esim.simPrice = action.payload.simPrice;
    },
    changeProduct: (state, action) => {
      const newPrice = action.payload.product.additionalPrice;
      const oldPrice = state.productsInfo.products[action.payload.index].products.find((x) => x.isSelected).additionalPrice;
      state.productsInfo.products[action.payload.index].products.map((product, key) => {
        if (product.productMakat == action.payload.product.productMakat) {
          product.isSelected = true;
        } else {
          product.isSelected = false;
        }
      });
      state.totalPrice = state.totalPrice - oldPrice + newPrice;
    },
    upgradeProduct: (state, action) => {
      const productId = action.payload.productId;
      const isChecked = action.payload.isChecked;
      const selectedProduct = state.productsInfo.productsForUpgrade.find((x) => x.productId == productId);
      if (!selectedProduct || selectedProduct == null) {
        return;
      }
      if (isChecked) {
        state.productsInfo.selectedProducts = [selectedProduct];
        state.epiServer.configuration.welcomeText = selectedProduct.name;
        state.totalPrice = parseFloat((state.epiServer.offerInfo.basePrice + selectedProduct.additionalPrice).toFixed(2));
        state.isProductUpgraded = true;
      } else {
        const baseProduct =
          state.selectedAddress.infrastructure.tashtitType == 'BF'
            ? state.productsInfo.baseBezeqFiberProduct
            : state.productsInfo.allProducts[0];
        state.productsInfo.selectedProducts = [baseProduct];
        state.epiServer.configuration.welcomeText = baseProduct.name;
        state.totalPrice = parseFloat((state.epiServer.offerInfo.basePrice + baseProduct.additionalPrice).toFixed(2));
        state.isProductUpgraded = false;
      }
    },
    setPremiumPackageChanged: (state, action) => {
      const premiumPackage = state.premiumPackages.find((x) => x.id == action.payload.id);
      const vas = premiumPackage.vasList.find((x) => x.id == action.payload.vasId);
      if (!vas || vas == null) {
        return;
      }
      const isUpdatePrice = action.payload.isSelected != premiumPackage.isSelected;
      if (isUpdatePrice == false) {
        return;
      }
      premiumPackage.isSelected = action.payload.isSelected;
      vas.isSelected = action.payload.isSelected;
      if (premiumPackage.isSelected) {
        if (vas.durationInDays < 30) {
          state.totalPriceOneTime = parseFloat((state.totalPriceOneTime + vas.price).toFixed(2));
        } else {
          state.totalPrice = parseFloat((state.totalPrice + vas.price).toFixed(2));
        }
      } else {
        if (vas.durationInDays < 30) {
          state.totalPriceOneTime = parseFloat((state.totalPriceOneTime - vas.price).toFixed(2));
        } else {
          state.totalPrice = parseFloat((state.totalPrice - vas.price).toFixed(2));
        }
      }
    },
    setProductVasChanged: (state, action) => {
      const selectedProduct = state.productsInfo.selectedProducts.pop();
      const vas = selectedProduct.vasList.find((x) => x.id == action.payload.id);
      if (!vas || vas == null) {
        return;
      }
      const isUpdatePrice = action.payload.isSelected != vas.isSelected;
      vas.isSelected = action.payload.isSelected;
      vas.isOpenPopUp = false;
      if (isUpdatePrice) {
        if (vas.isSelected) {
          var result = parseFloat((state.totalPrice + vas.price).toFixed(2));
          state.totalPrice = result;
        } else {
          var result = parseFloat((state.totalPrice - vas.price).toFixed(2));
          state.totalPrice = result;
        }
      }
      const selectedVasList = selectedProduct.vasList.filter((x) => x.isSelected == true);
      selectedProduct.selectedVasList = selectedVasList;
      selectedProduct.selectedVasIdList = selectedVasList?.map((x) => x.id);
      state.productsInfo.selectedProducts.push(selectedProduct);
    },
    setProductVasPopupChanged: (state, action) => {
      const selectedProduct = state.productsInfo.selectedProducts.pop();
      const vas = selectedProduct.vasList.find((x) => x.id == action.payload.id);
      if (!vas || vas == null) {
        return;
      }
      vas.isOpenPopUp = action.payload.isOpenPopUp;
      state.productsInfo.selectedProducts.push(selectedProduct);
    },
    setVasPopupChanged: (state, action) => {
      const premiumPackage = state.premiumPackages.find((x) => x.id == action.payload.id);
      if (!premiumPackage || premiumPackage == null) {
        return;
      }
      premiumPackage.isOpenPopUp = action.payload.isOpenPopUp;
    },
    displayProductVas: (state, action) => { }, //for report only
    selectProductVas: (state, action) => { }, //for report only
    setCellularPackage: (state, action) => {
      const productId = action.payload;
      const selectedProduct = state.productsInfo.productsForUpgrade.find((x) => x.productId == productId);
      state.productsInfo.baseProduct = selectedProduct;
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload.selectedAddress;
    },
    setIsUserAddressLoaded: (state, action) => {
      state.isUserAddressLoaded = action.payload;
    },
    setIsOtherAddress: (state, action) => {
      state.isOtherAddress = action.payload;
    },
    setIsSkipToNewCustomer: (state, action) => {
      state.isSkipToNewCustomer = action.payload;
    },
    setIsCustomerExposureSuccess: (state, action) => {
      state.isCustomerExposureSuccess = action.payload;
    },
    setUserAddresses: (state, action) => {
      state.userAddresses = action.payload.userAddresses;
    },
    setZipCode: (state, action) => {
      state.selectedAddress.zipCode = action.payload.zipCode;
    },
    setPersonalInfo: (state, action) => {
      //state.personalInfo = action.payload.personalInfo;
      state.personalInfo.firstName = action.payload.personalInfo.firstName
        ? action.payload.personalInfo.firstName
        : state.personalInfo.firstName;
      state.personalInfo.lastName = action.payload.personalInfo.lastName
        ? action.payload.personalInfo.lastName
        : state.personalInfo.lastName;
      state.personalInfo.id = action.payload.personalInfo.id ? action.payload.personalInfo.id : state.personalInfo.id;
      state.personalInfo.email = action.payload.personalInfo.email ? action.payload.personalInfo.email : state.personalInfo.email;
      state.personalInfo.isReceivingAd = action.payload.personalInfo.isReceivingAd
        ? action.payload.personalInfo.isReceivingAd
        : state.personalInfo.isReceivingAd;
      state.personalInfo.isReceivingBill = action.payload.personalInfo.isReceivingBill
        ? action.payload.personalInfo.isReceivingBill
        : state.personalInfo.isReceivingBill;
      state.personalInfo.ban = action.payload.personalInfo.ban ? action.payload.personalInfo.ban : state.personalInfo.ban;
    },
    setIsReceivingAd: (state, action) => {
      state.personalInfo.isReceivingAd = action.payload;
    },
    setAccountInfo: (state, action) => {
      state.accountInfo = action.payload.accountInfo;
    },
    setLoginData: (state, action) => {
      state.personalInfo.id = action.payload.id;
      state.personalInfo.firstName = action.payload.firstName;
      state.personalInfo.lastName = action.payload.lastName;
      state.otpPhone = action.payload.contactNumber;
      state.otpIdentity = action.payload.id;
      state.flowType = 'existsCustomer';
    },
    setCustomerEmail: (state, action) => {
      state.personalInfo.email = action.payload.email;
    },
    setIsReceivingBill: (state, action) => {
      state.personalInfo.isReceivingBill = action.payload.isReceivingBill;
    },
    setOtpPhone: (state, action) => {
      state.otpPhone = action.payload.otpPhone;
    },
    setOtpCode: (state, action) => {
      state.otpCode = action.payload.otpCode;
    },
    setOtpTicketId: (state, action) => {
      state.otpTicketId = action.payload.otpTicketId;
    },
    setOtpIdentity: (state, action) => {
      state.otpIdentity = action.payload.identity;
      state.personalInfo.id = action.payload.identity;
    },
    setWrongOtpMessage: (state, action) => {
      state.wrongOtpMessage = action.payload.wrongOtpMessage;
    },
    setPayment: (state, action) => {
      state.payment = action.payload.payment;
    },
    setPhoneForDelivery: (state, action) => {
      state.phoneForDelivery = action.payload.phoneForDelivery;
    },
    setTechnicianArrivalTime: (state, action) => {
      state.technicianArrivalTime = action.payload.technicianArrivalTime;
    },
    setTechnicianArrivalTimeIbc: (state, action) => {
      state.technicianArrivalTimeIbc = action.payload.technicianArrivalTimeIbc;
    },
    setFloor: (state, action) => {
      state.selectedAddress.floor = action.payload.floor;
    },
    setSetupDeliveries: (state, action) => {
      var todaysDate = new Date();
      var lfdat = new Date(action.payload.setupDeliveries.lfdat);
      if (lfdat.toDateString() == todaysDate.toDateString()) {
        state.deliveryCost = state.epiServer.configuration.deliveryCostForToday;
      } else {
        state.deliveryCost = state.epiServer.configuration.deliveryCost;
      }
      state.setupDeliveries = action.payload.setupDeliveries;
    },
    setSupplyType: (state, action) => {
      state.supplyType = action.payload.supplyType;
    },
    setIsCustomerConnectedToIbc: (state, action) => {
      state.isCustomerConnectedToIbc = action.payload;
    },
    setNvIipSeq: (state, action) => {
      state.nvIipSeq = action.payload;
    },
    setBan: (state, action) => {
      state.personalInfo.ban = action.payload.ban;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload.totalPrice;
    },
    addTotalPriceOneTime: (state, action) => {
      state.totalPriceOneTime += action.payload;
    },
    currentTotalPriceOneTime: (state, action) => {
      state.totalPriceOneTime = action.payload;
    },
    addTotalPrice: (state, action) => {
      state.totalPrice += action.payload;
    },
    addAttempt: (state, action) => {
      state.numOfAttempts = state.numOfAttempts + 1;
    },
    setError: (state, action) => {
      state.error.id = action.payload.id;
      if (action.payload.isOpenWorkOrder) {
        callOpenWorkOrderForSale(state);
      }
      state.page = 'errorPage';
      state.error.isDisplay = action.payload.isDisplay;
    },
    clearSale: (state, action) => { },
    setSelectedInternetPackage: (state, action) => {
      const selectedProduct = action.payload;
      //----------- set selected offer -----------
      const epiOffers = state.epiServer.saleBlock.epiOffers;
      for (let i = 0; i < epiOffers.length; i++) {
        const offer = epiOffers[i];
        if (selectedProduct.offerId == offer.contentLink.id) {
          state.epiServer.offerInfo = { offerId: offer.contentLink.id, title: offer.title.value, basePrice: offer.basePrice.value };
          break;
        }
      }
      //----------- set selected offer -----------
      state.productsInfo.baseProduct = selectedProduct;
      state.productsInfo.selectedProducts = [selectedProduct];
      state.epiServer.configuration.welcomeText = selectedProduct.name;
      state.totalPrice = parseFloat((state.epiServer.offerInfo.basePrice + selectedProduct.additionalPrice).toFixed(2));
      if (state.selectedAddress.infrastructure.tashtitType == 'BF') {
        state.productsInfo.productsForUpgrade = state.productsInfo.bezeqFiberProducts.filter(
          (x) => x.downloadSpeed > selectedProduct.downloadSpeed
        );
      }
    },
    saveBaseBezeqFiberProduct: (state, action) => {
      const selectedProduct = action.payload;
      state.productsInfo.baseBezeqFiberProduct = selectedProduct;
    },
    setIsMeshUpgrade: (state, action) => {
      state.isMeshUpgrade = action.payload;
      if (state.isMeshUpgrade) {
        state.totalPrice = parseFloat((state.totalPrice + Config.meshUpgradeCost).toFixed(2));
      } else {
        state.totalPrice = parseFloat((state.totalPrice - Config.meshUpgradeCost).toFixed(2));
      }
    },
    setSimActivationList: (state, action) => {
      const simActivationList = action.payload;
      for (var i = 0; i < state.productsInfo.selectedProducts.length; i++) {
        const product = state.productsInfo.selectedProducts[i];
        const phone = product.isExistPhone ? product.existPhone : product.newPhone;
        let sim = simActivationList.find((x) => x.phone == phone);
        if (sim) {
          state.productsInfo.selectedProducts[i].simActivationCode = Config.simActivationCodePrefix + sim.simActivationCode;
        }
      }
    },
    setTransactionId: (state, action) => {
      state.transactionId = action.payload;
    },
    //validation
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload.isSubmit;
    },
    setIsValid: (state, action) => {
      state.isValid = action.payload.isValid;
    },
    reportAnalytics: (state, action) => { },
    reportTagManager: (state, action) => { },
    reportFbqAnalytics: (state, action) => { },
    openPopover: {
      reducer(state, action) {
        if (state.togglePopover === false) {
          state.togglePopover = true;
        }
      },
    },
    closePopover: {
      reducer(state, action) {
        if (state.togglePopover === true) {
          state.togglePopover = false;
        }
      },
    },
    reportSetSelectedProducts: (state, action) => { },
    reportAddressNotConnectedToFiber: (state, action) => { },
    reportNotAllowSale: (state, action) => { },
    setIsRegularSimClicked: (state, action) => {
      state.esim.isRegularSimClicked = action.payload;
    },
    setIsEsimClicked: (state, action) => {
      state.esim.isEsimClicked = action.payload;
    },
    setIsEsimNiudButton: (state, action) => {
      state.cellularOrderdetails.isEsimNiudExistOnOrder = action.payload;
    },
    setButtonsModeInCellularOrder: (state, action) => {
      state.cellularOrderdetails.buttonsMode = action.payload;
    },
    setButtonsModeTypeInCellularOrder: (state, action) => {
      state.cellularOrderdetails.buttonsModeType = action.payload;
    },
    addSelectedPhoneIndex: (state, action) => {
      state.productsInfo.selectedPhoneIndex = state.productsInfo.selectedPhoneIndex + 1;
    },
    markAsEsimProduct: (state, action) => {
      var index = state.productsInfo.selectedProducts.length - 1;
      Object.assign(state.productsInfo.selectedProducts[index], { isEsim: true });
      //change price
      //get from service.ESIM ..
      //state.base
      const currentFee = state.productsInfo.selectedProducts[index].oneTimeFee;
      state.productsInfo.selectedProducts[index].oneTimeFee = state.esim.eSimPrice;
      state.totalPriceOneTime = state.totalPriceOneTime + parseFloat(Math.abs(currentFee - state.esim.eSimPrice));
      const simExists = state.productsInfo.selectedProducts.some((p) => {
        return !p.isEsim ? true : false;
      });
      if (!simExists) {
        state.esim.saleType = eSimSaleType.eSimOnly;
      } else {
        state.esim.saleType = eSimSaleType.mixed;
      }
    },
    markAsSimProduct: (state, action) => {
      var index = state.productsInfo.selectedProducts.length - 1;
      Object.assign(state.productsInfo.selectedProducts[index], { isEsim: false });
      const eSimExists = state.productsInfo.selectedProducts.some((p) => {
        return p.isEsim ? true : false;
      });
      if (eSimExists) {
        state.esim.saleType = eSimSaleType.mixed;
      } else {
        state.esim.saleType = eSimSaleType.simOnly;
      }
    },
    setRegularNumChosenCount: (state, action) => {
      state.RegularNumChosenCount += action.payload;
    },
    setPrettyNumChosenCount: (state, action) => {
      state.PrettyNumChosenCount += action.payload;
    },
    setRegularNumChosenReset: (state, action) => {
      state.RegularNumChosenCount = action.payload;
    },
    setPrettyNumChosenReset: (state, action) => {
      state.PrettyNumChosenCount = action.payload;
    },
  },
  extraReducers: {
    [getSaleCatalogAsync.fulfilled]: (state, action) => {
      if (!action.payload) {
        return;
      }
      state.catalog = action.payload.catalog;
    },
    [checkUserAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.checkUser = action.payload;
    },
  },
});
export const {
  setRegularNumChosenReset,
  setPrettyNumChosenReset,
  setPrettyNumChosenCount,
  setRegularNumChosenCount,
  setIsRegularSimClicked,
  setIsEsimClicked,
  resetBlock,
  initSale,
  redirectToLogin,
  checkIfBackFromLogin,
  addSelectedPhone,
  removeSelectedPhone,
  setCellularServices,
  setProductsInfo,
  goToPage,
  setFlowType,
  setSaleDetails,
  addProduct,
  removeProduct,
  changeProduct,
  upgradeProduct,
  setSelectedProducts,
  setPremiumPackageChanged,
  setProductVasChanged,
  setProductVasPopupChanged,
  setVasPopupChanged,
  displayProductVas,
  selectProductVas,
  setCellularPackage,
  setSelectedAddress,
  setIsUserAddressLoaded,
  setIsOtherAddress,
  setIsSkipToNewCustomer,
  setIsCustomerExposureSuccess,
  setUserAddresses,
  setZipCode,
  setPersonalInfo,
  setIsReceivingAd,
  setAccountInfo,
  setLoginData,
  setCustomerEmail,
  setIsReceivingBill,
  setOtpPhone,
  setOtpCode,
  setPayment,
  setPhoneForDelivery,
  setTechnicianArrivalTime,
  setTechnicianArrivalTimeIbc,
  setFloor,
  setSetupDeliveries,
  setSupplyType,
  setIsCustomerConnectedToIbc,
  setNvIipSeq,
  setTotalPrice,
  addTotalPriceOneTime,
  currentTotalPriceOneTime,
  addTotalPrice,
  setError,
  clearSale,
  setBan,
  setTransactionId,
  setIsSubmit,
  setIsValid,
  reportAnalytics,
  reportTagManager,
  reportFbqAnalytics,
  setOtpTicketId,
  setOtpIdentity,
  setWrongOtpMessage,
  addAttempt,
  setIsMeshUpgrade,
  setSimActivationList,
  setSelectedInternetPackage,
  saveBaseBezeqFiberProduct,
  openPopover,
  closePopover,
  reportSetSelectedProducts,
  reportAddressNotConnectedToFiber,
  reportNotAllowSale,
  navigateTo,
  markAsEsimProduct,
  updateSimPrices,
  markAsSimProduct,
  setButtonsModeInCellularOrder,
  setButtonsModeTypeInCellularOrder,
  setIsEsimNiudButton,
  addSelectedPhoneIndex,
} = saleBlockSlice.actions;
export default saleBlockSlice.reducer;
function getSaleTypeName(saleType) {
  switch (saleType) {
    case 0:
      return 'tv';
      break;
    case 1:
      return 'app';
      break;
    case 2:
      return 'cellular';
      break;
    case 3:
      return 'internet';
      break;
    default:
      return '';
  }
}
function getLoginTemplate(saleType) {
  switch (saleType) {
    case 'tv':
      return 'SALE_TV';
      break;
    case 'app':
      return 'SALE_APP';
      break;
    case 'cellular':
      return 'SALE_CELLULAR';
      break;
    case 'internet':
      return 'SALE_FIBER';
      break;
    default:
      return '';
  }
}
function getProgressBarPoints(saleType, flowType) {
  let progressBarPoints = [];
  switch (saleType) {
    case 'tv':
      progressBarPoints = flowType == 'existsCustomer' ? [11, 22, 33, 44, 55, 66, 77, 88] : [9, 18, 27, 36, 45, 54, 63, 72, 81, 90];
      break;
    case 'app':
      progressBarPoints = [14, 28, 42, 56, 70, 84];
      break;
    case 'cellular':
      progressBarPoints = flowType == 'existsCustomer' ? [14, 28, 42, 56, 70, 84] : [10, 20, 30, 40, 50, 60, 70, 80, 90];
      break;
    case 'internet':
      progressBarPoints = flowType == 'existsCustomer' ? [12, 24, 36, 48, 60, 72, 84] : [10, 20, 30, 40, 50, 60, 70, 80, 90];
      break;
  }
  return progressBarPoints;
}
function setCustomerProducts(allProducts, customerProducts, rules, totalPrice) {
  let products = [];
  customerProducts.map((productObj, index) => {
    let productObject = { count: 0, products: [] };
    allProducts.map((product, key) => {
      let productWithRule = setRules(rules, product, index);
      productWithRule.index = index;
      if (index > 0) {
        productObject.count++;
        productWithRule.isSelected = productObj.products.find((x) => x.productMakat == productWithRule.productMakat)?.isSelected ?? false;
        productObject.products.push(productWithRule);
      } else {
        if (product.minimumQuantity == 1) {
          productWithRule.isSelected = true;
          productObject.count = 1;
          productObject.products.push(productWithRule);
        }
      }
    });
    products.push(productObject);
  });
  return products;
}
function getSelectedProducts(products) {
  let selectedProducts = [];
  products.map((productObj, index) => {
    productObj.products.map((product, key) => {
      if (product.isSelected) {
        selectedProducts.push(product);
      }
    });
  });
  return selectedProducts;
}
function getTotalProductsPrice(customerProducts) {
  let totalProductsPrice = 0;
  customerProducts.map((productObj, index) => {
    productObj.products.map((product, index) => {
      if (product.isSelected) {
        totalProductsPrice += product.additionalPrice;
      }
    });
  });
  return totalProductsPrice;
}
function getVasList(epiVasList) {
  if (epiVasList == null) {
    return null;
  }
  let vasList = [];
  epiVasList.map((data, index) => {
    let textWithIconList = data.textWithIconList?.expandedValue?.map((item, i) => {
      return { text: item.text?.value, icon: item.icon?.value?.url };
    });
    let vas = {
      id: data.contentLink.id,
      socName: data.socName?.value,
      title: data.title?.value,
      shortDescription: data.shortDescription?.value,
      durationInDays: data.durationInDays?.value != null ? data.durationInDays.value : 0,
      buttonRemark: data.buttonRemark?.value,
      price: data.basePrice?.value != null ? data.basePrice.value : 0,
      priceText: data.priceText?.value,
      isTvSoc: !!data.isTvSoc?.value,
      isVirtualSoc: !!data.isVirtualSoc?.value,
      promoImage: data.promoImage.value?.url,
      isDefault: !!data.isDefault?.value,
      isMandatory: !!data.isMandatory?.value,
      isEnabled: !!data.isEnabled?.value,
      //PopUp
      popUpTitle: data.popUpTitle?.value,
      popUpSubTitle: data.popUpSubTitle?.value,
      extendedImage: data.extendedImage.value?.url,
      textWithIconList: textWithIconList,
      details: data.details?.value,
      remark: data.remark?.value,
      descriptionURL: data.descriptionURL?.value,
      //additionalParams
      isSelected: false,
      isOpenPopUp: false,
    };
    vasList.push(vas);
  });
  return vasList;
}
function getPremiumPackages(listPremiumPackages) {
  if (!listPremiumPackages || listPremiumPackages.length == 0) {
    return [];
  }
  let premiumPackages = [];
  for (let i = 0; i < listPremiumPackages.length; i++) {
    const data = listPremiumPackages[i];
    let premiumPackage = {
      id: data.contentLink.id,
      title: data.title.value,
      image: data.promoImage.value?.url,
      price: data.basePrice?.value != null ? data.basePrice.value : 0,
      priceText: data.priceText?.value,
      description: data.description?.value,
      isMobileSupport: !!data.isMobileSupport?.value,
      isDefault: !!data.isDefault?.value,
      isMandatory: !!data.isMandatory?.value,
      channelList: getChannelList(data.listChannels.expandedValue),
      vasList: getVasList(data.listVases.expandedValue),
      //additionalParams
      isSelected: false,
      isOpenPopUp: false,
    };
    premiumPackages.push(premiumPackage);
  }
  return premiumPackages;
}
function getChannelList(listChannels) {
  if (listChannels == null) {
    return [];
  }
  let channelList = [];
  listChannels.map((data, index) => {
    let channel = {
      name: data.channelName?.value,
      image: data.image.value?.url,
    };
    channelList.push(channel);
  });
  return channelList;
}
function getProducts(productList, offerId) {
  if (!productList || productList == null) {
    return [];
  }
  let products = [];
  productList.map((data, index) => {
    let product = {
      productId: data.contentLink.id,
      offerId: offerId,
      index: index,
      productMakat: data.productMakat.value,
      productIdDelivery: data.productIdDelivery.value,
      productMakatVirtual: data.productMakatVirtual.value,
      additionalPrice: data.additionalPrice.value,
      priceBeforeDiscount: data.priceBeforeDiscount.value,
      name: data.name,
      minimumQuantity: data.minimumQuantity.value,
      maximumQuantity: data.maximumQuantity.value,
      downloadSpeed: data.downloadSpeed?.value,
      uploadSpeed: data.uploadSpeed?.value,
      isInternetOpenPackage: !!data.isInternetOpenPackage?.value,
      isSelected: false,
      productTermsLink: data.productTermsLink?.value,

      programDetailsLink: buildUrl(data.programDetailsLink?.value),
      connectionAgreementLink: buildUrl(data.connectionAgreementLink?.value),

      oneTimeFee: data.oneTimeFee?.value,
      isCustomerBasedPackage: !!data.isCustomerBasedPackage?.value,
      circleBannerText: data.circleBannerText,
      cornerBannerText: data.cornerBannerText,
      callsAndMessages: data.callsAndMessages,
      minutesForAbroadCalls: data.minutesForAbroadCalls,
      vasList: getVasList(data.listVASes.expandedValue),
      selectedVasList: [],
      selectedVasIdList: [],
      isDisplaySimActivation: !!data.isDisplaySimActivation.value,
      activateSimUrl: data.activateSimUrl.value,
      regularNumbersCount: data.regularNumbersCount.value,
      prettyNumbersCount: data.prettyNumbersCount.value,
      prettyNumberName: data.prettyNumberName.value,
      prettyNumberDiscountSOC: data.prettyNumberDiscountSOC.value,
      prettyNumberPrice: data.prettyNumberPrice.value,
      prettyNumberUnderBtnText: data.prettyNumberUnderBtnText.value,
    };
    products.push(product);
  });
  return products;
}
function distinct(products) {
  let distinctList = [];
  for (let i = 0, index = 0; i < products.length; i++) {
    const isExists = distinctList.find((element) => element.productId == products[i].productId);
    if (!isExists) {
      products[i].index = index;
      distinctList.push(products[i]);
      index++;
    }
  }
  return distinctList;
}
//------------------ createAsyncThunk ------------------
export const setSelectedProductsAsync = createAsyncThunk('saleBlock/setSelectedProductsAsync', async (data, thunkAPI) => {
  thunkAPI.dispatch(saleBlockSlice.actions.setSelectedProducts());
  const state = thunkAPI.getState().saleBlock;
  const eventLabel = state.productsInfo.selectedProducts[0]?.name;
  thunkAPI.dispatch(
    saleBlockSlice.actions.reportAnalytics({
      eventCategory: 'tv_newsale_process',
      eventAction: state.flowType == 'existsCustomer' ? 'click_9' : 'click_22',
      eventLabel: eventLabel,
    })
  );
});

export const createOtpForNewCustomerAsync = createAsyncThunk('saleBlock/createOtpForNewCustomerAsync', async (data, thunkAPI) => {
  const state = thunkAPI.getState().saleBlock;
  if (state.saleType != 'internet') {
    return;
  }
  try {
    const contactNumber = data.contactNumber;
    const identity = data.identity;
    if (contactNumber && identity) {
      let step1Ticket = '';
      //------------ createOtp ------------
      //thunkAPI.dispatch(showAppLoader());
      try {
        const captchaToken = await getRecaptchaToken('OtpVerifyPhonePage');
        if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
          return;
        }
        const result = await ProviderManager.getProviderData('createOtp', [contactNumber, false, captchaToken]);
        if (result.Body && result.Body.step1Ticket) {
          step1Ticket = result.Body.step1Ticket;
        }
      } catch (error) {
      } finally {
        //thunkAPI.dispatch(hideAppLoader());
      }
      //------------ createOtp ------------
      if (step1Ticket && step1Ticket != '') {
        thunkAPI.dispatch(setOtpTicketId({ otpTicketId: step1Ticket }));
        thunkAPI.dispatch(setOtpPhone({ otpPhone: contactNumber }));
        thunkAPI.dispatch(setOtpIdentity({ identity: identity }));
        thunkAPI.dispatch(setFormDetails({ phone: contactNumber, id: identity }));
      }
      thunkAPI.dispatch(goToPage({ page: 'otpVerifyCode', percent: 30 }));
    } else {
      thunkAPI.dispatch(goToPage({ page: 'otpVerifyPhone', percent: 20 }));
    }
  } catch (error) { }
});
//------------------ createAsyncThunk ------------------
